export default __webpack_public_path__ + "static/media/Campaign.1d626c88cd35dc4a5c3e738a6dd21a7f.svg";